export const FETCH_SME_REQUESTS_REQUEST = 'FETCH_SME_REQUESTS_REQUEST';
export const FETCH_SME_REQUESTS_SUCCESS = 'FETCH_SME_REQUESTS_SUCCESS';
export const FETCH_SME_REQUESTS_FAILURE = 'FETCH_SME_REQUESTS_FAILURE';
export const APPROVE_SME_REQUEST = 'APPROVE_SME_REQUEST';
export const APPROVE_SME_SUCCESS = 'APPROVE_SME_SUCCESS';
export const APPROVE_SME_FAILURE = 'APPROVE_SME_FAILURE';
export const REJECT_SME_REQUEST = 'REJECT_SME_REQUEST';
export const REJECT_SME_SUCCESS = 'REJECT_SME_SUCCESS';
export const REJECT_SME_FAILURE = 'REJECT_SME_FAILURE';
export const FETCH_CONTENT_REQUESTS_REQUEST = 'FETCH_CONTENT_REQUESTS_REQUEST';
export const FETCH_CONTENT_REQUESTS_SUCCESS = 'FETCH_CONTENT_REQUESTS_SUCCESS';
export const FETCH_CONTENT_REQUESTS_FAILURE = 'FETCH_CONTENT_REQUESTS_FAILURE';
export const APPROVE_CONTENT_REQUEST = 'APPROVE_CONTENT_REQUEST';
export const APPROVE_CONTENT_SUCCESS = 'APPROVE_CONTENT_SUCCESS';
export const APPROVE_CONTENT_FAILURE = 'APPROVE_CONTENT_FAILURE';